import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const COLORS = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FDCB6E', '#6C5CE7', '#FF8ED4'];

const Roulette = ({ prize, allPrizes, onComplete }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);

  // Fallback items if none provided
  const items = allPrizes?.length > 0 ? allPrizes : [
    { label: 'A', points: 10 }, { label: 'B', points: 20 }, 
    { label: 'C', points: 30 }, { label: 'D', points: 40 },
    { label: 'E', points: 50 }, { label: 'F', points: 60 }
  ];

  const numSegments = items.length;
  const segmentAngle = 360 / numSegments;

  const spin = () => {
    if (isSpinning || !prize) return;
    setIsSpinning(true);

    // Find index of the won prize
    const prizeIndex = items.findIndex(item => item.label === prize.label);
    const targetIndex = prizeIndex >= 0 ? prizeIndex : 0;

    // Calculate rotation:
    // We want the center of the target segment to be at the top (0 degrees / 360 degrees)
    // Extra spins for visual effect (e.g., 5 full spins)
    const extraSpins = 360 * 5;
    
    // The top pointer is at 0 degrees. 
    // Segment 0 spans from -segmentAngle/2 to +segmentAngle/2.
    // To land on targetIndex, we rotate backwards by (targetIndex * segmentAngle)
    const targetRotation = extraSpins + (360 - (targetIndex * segmentAngle));
    
    // Add a slight random offset so it doesn't land perfectly in the center every time
    const randomOffset = (Math.random() * segmentAngle * 0.6) - (segmentAngle * 0.3);

    const finalRotation = rotation + targetRotation + randomOffset;
    setRotation(finalRotation);

    // Wait for animation to finish
    setTimeout(() => {
      setIsSpinning(false);
      onComplete();
    }, 4000); // Matches CSS transition duration
  };

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-64 h-64 mb-8">
        {/* Pointer */}
        <div className="absolute top-[-15px] left-1/2 -translate-x-1/2 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[25px] border-t-remo-accent z-20 drop-shadow-md" />
        
        {/* Wheel container */}
        <div 
          className="w-full h-full rounded-full border-4 border-white shadow-xl overflow-hidden relative transition-transform duration-[4000ms] ease-[cubic-bezier(0.25,0.1,0.15,1)]"
          style={{ transform: `rotate(${rotation}deg)` }}
        >
          {items.map((item, index) => {
            const rotateAngle = index * segmentAngle;
            // Create pie slices using CSS conic-gradient on a pseudo-element or individual divs
            // A simpler approach for React is absolute positioned divs clipped
            return (
              <div
                key={index}
                className="absolute top-0 left-0 w-full h-full"
                style={{
                  clipPath: `polygon(50% 50%, 50% 0%, 100% 0%, 100% 50%)`, // Simplified, better approach below
                  transform: `rotate(${rotateAngle}deg)`,
                }}
              >
                {/* We use a conic gradient background for the whole wheel instead for better rendering accuracy */}
              </div>
            );
          })}

          {/* Better Wheel Rendering using conic-gradient */}
          <div 
            className="absolute inset-0"
            style={{
              background: `conic-gradient(${items.map((_, i) => 
                `${COLORS[i % COLORS.length]} ${i * segmentAngle}deg ${(i + 1) * segmentAngle}deg`
              ).join(', ')})`
            }}
          />

          {/* Labels */}
          {items.map((item, index) => {
            const rotateAngle = (index * segmentAngle) + (segmentAngle / 2);
            return (
              <div
                key={index}
                className="absolute top-0 left-0 w-full h-full flex justify-center items-start pt-4 text-white font-bold text-sm drop-shadow-md"
                style={{ transform: `rotate(${rotateAngle}deg)` }}
              >
                <div className="transform -rotate-90 origin-bottom">
                  {item.points}pt
                </div>
              </div>
            );
          })}

          {/* Center Decor */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-inner border-4 border-gray-200" />
        </div>
      </div>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={spin}
        disabled={isSpinning || !prize}
        className={`px-8 py-3 rounded-full text-white font-bold text-xl shadow-[0_4px_0_rgb(0,119,67)] active:shadow-[0_0px_0_rgb(0,119,67)] active:translate-y-1 transition-all ${isSpinning ? 'bg-gray-400 cursor-not-allowed' : 'bg-remo-main hover:bg-[#008f4f]'}`}
      >
        {isSpinning ? 'SPINNING...' : 'SPIN'}
      </motion.button>
    </div>
  );
};

export default Roulette;